import { Model, ModelClass } from './Model';
import { UserType } from './User';

export const GAMEBREAKER_WHOLESALER_ID = 1;
export interface WholesalerType extends ModelClass {
    id: number;
    company_name: string;
    user: UserType;
    lakeshore_id: number;
}

export const Wholesaler = Model<WholesalerType>('Wholesaler', { endpoint: 'wholesalers' })`
    id: Int;
    company_name: String;
    user: Any;
    lakeshore_id: Int;
`;
